var map = {
	"./favicon-32x32.png": 9421,
	"./logo-white.png": 9082,
	"./logo.png": 9295,
	"./logo_white.png": 8495,
	"./main-slider/front-heroe2.png": 3500,
	"./offer-printing-lease/canon-logo.png": 4818,
	"./offer-printing-lease/drukarka.png": 6050,
	"./offer-printing-lease/drukarki_dzierzaw_MP6055.png": 8329,
	"./offer-printing-lease/drukarki_dzierzawa_MPC3504.png": 9152,
	"./offer-printing-lease/drukarki_dzierzawa_gx4040.png": 6168,
	"./offer-printing-lease/drukarki_dzierzawa_gx7040.png": 218,
	"./offer-printing-lease/drukarki_dzierzawa_l4266.png": 2495,
	"./offer-printing-lease/drukarki_dzierzawa_l6570.png": 4709,
	"./registersOffer/bingo-online-logo.png": 8217,
	"./registersOffer/ergo-online-logo.png": 8757,
	"./registersOffer/kasa_1.png": 3298,
	"./registersOffer/kasa_2.png": 1488,
	"./registersOffer/kasa_3.png": 9053,
	"./registersOffer/kasa_4.png": 9247,
	"./registersOffer/mobile-online-logo.png": 7023,
	"./registersOffer/registers2.png": 5063,
	"./registersOffer/revo-online-logo.png": 3325,
	"./serviceOffer/urzadzenia-serwisowe2.png": 7528,
	"./soc_fb.png": 4320,
	"./soc_insta.png": 1496
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 260;